import React from 'react';
import { ArrowLeft, Package } from 'lucide-react';

// Grille de grandes tuiles (design Commande) : 2 colonnes mobile, 3 desktop
export const TileGrid = ({ tiles, onSelect, testId = 'category-tiles' }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-8" data-testid={testId}>
    {tiles.map(t => {
      const Icon = t.icon || Package;
      const cfg = t.cfg || { bg: 'bg-gray-100', color: 'text-gray-500', border: 'border-gray-200' };
      return (
        <button key={t.id} type="button" onClick={() => onSelect(t.id)}
          className={`relative text-left min-h-[132px] md:min-h-[160px] rounded-3xl bg-white border-2 ${t.badge ? 'border-neon-pink/50 shadow-neon-pink' : cfg.border} hover:shadow-card-stack hover:-translate-y-0.5 active:scale-[0.98] transition-all p-4 flex flex-col justify-between focus:outline-none focus:ring-2 focus:ring-neon-pink/40`}
          data-testid={`${t.testPrefix || 'cat-tile'}-${t.id}`}>
          <div className={`w-14 h-14 md:w-16 md:h-16 ${cfg.bg} rounded-2xl flex items-center justify-center`}><Icon className={cfg.color} size={34} strokeWidth={2.2} /></div>
          <div className="mt-3">
            <span className="block font-heading text-gray-900 text-lg md:text-xl font-bold uppercase tracking-wide leading-tight">{t.label}</span>
            {t.sub && <span className="text-gray-400 text-xs">{t.sub}</span>}
          </div>
          {t.badge ? <span className="absolute top-3 right-3 min-w-[28px] h-7 px-2 rounded-full bg-neon-pink text-white text-sm font-bold flex items-center justify-center shadow-neon-pink" data-testid={`${t.testPrefix || 'cat-tile'}-count-${t.id}`}>{t.badge}</span> : null}
        </button>
      );
    })}
  </div>
);

export const BackButton = ({ onClick, label = 'Toutes les catégories', testId = 'cat-back-btn' }) => (
  <button type="button" onClick={onClick} className="flex items-center gap-2 h-10 px-4 rounded-full bg-white border border-gray-200 text-sm font-medium text-gray-700 hover:border-neon-pink/40 hover:text-neon-pink transition-colors" data-testid={testId}>
    <ArrowLeft size={16} />{label}
  </button>
);

// En-tête coloré d'une section (liste d'une catégorie / d'un poste)
export const SectionHeader = ({ icon: Icon = Package, cfg, label, sub, right }) => (
  <div className={`px-5 py-4 flex items-center justify-between ${cfg?.bg || 'bg-gray-100'}`}>
    <div className="flex items-center gap-3">
      <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center shadow-sm"><Icon className={cfg?.color || 'text-gray-500'} size={28} strokeWidth={2.2} /></div>
      <div className="text-left">
        <h3 className="font-heading font-bold uppercase tracking-wide text-gray-900">{label}</h3>
        {sub && <span className="text-xs text-gray-500">{sub}</span>}
      </div>
    </div>
    {right}
  </div>
);
